// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-3b234135]{font-family:Vazir,serif!important;white-space:break-spaces;overflow:hidden}", ""]);
// Exports
module.exports = exports;
